<template>
  <div class="d-inline-flex align-items-center">
    <div
      :class="['brand-img-container bg-dark rounded-circle overflow-hidden d-flex mr-2', brandImgContainerClass]">
      <img
        :src="displaySelectedBrand.brand_image"
        :alt="displaySelectedBrand.name"
        @load="onImgLoad"
        ref="brandImg">
    </div>
    <b-dropdown
      id="cc-brand-dropdown"
      :text="displaySelectedBrand.name"
      toggle-class="bg-transparent shadow-none border-0 p-0 text-left"
      menu-class="p-0 mt-2 bg-white">
      <template v-if="loading.brands">
        <b-dropdown-item>Loading...</b-dropdown-item>
      </template>
      <template v-else>
        <b-dropdown-item
          v-for="brand in brands"
          :key="`brand-${brand.name}`"
          class="py-2 px-3 d-inline-block align-items-center justify-content-between"
          @click="setSelectedBrand(brand.uuid)"
          :title="brand.name">
          {{ brand.name }}
          <span class="count px-2 d-none" v-if="brand.count > 0">{{ brand.count }}</span>
        </b-dropdown-item>
      </template>
    </b-dropdown>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      brandImgContainerClass: '',
    }
  },
  computed: {
    ...mapGetters({
      brands: "conversationalCommerce/brands",
      selectedBrand: "conversationalCommerce/selectedBrand",
      loading: "conversationalCommerce/loading"
    }),
    displaySelectedBrand: {
      get() {
        return this.selectedBrand
          ? this.brands.find(brand => brand.uuid === this.selectedBrand)
          : { name: '', brand_image: '' };
      },
      set(brand) {
        return brand;
      }
    }
  },
  async created() {
    await this.$store.dispatch("conversationalCommerce/getBrands");
    if (this.brands.length > 0) this.$store.commit("conversationalCommerce/setSelectedBrand", this.brands[0].uuid);

  },
  methods: {
    onImgLoad() {
      const image = new Image();
      image.src = this.$refs.brandImg.src;
      if (image.width > image.height) this.brandImgContainerClass = 'align-items-center justify-content-center max-h-100';
      else if (image.height > image.width) this.brandImgContainerClass = 'align-items-center justify-content-center max-w-100';
    },
    setSelectedBrand(uuid) {
      this.$store.commit("conversationalCommerce/setSelectedBrand", uuid);
    }
  }
}
</script>

<style lang="scss" scoped>
.brand-img-container {
  width: 49px;
  height: 49px;
  img {
    object-fit: cover;
  }
  &.max-h-100 > img {
    max-height: 100%;
  }
  &.max-w-100 > img {
    max-width: 100%;
  }
}
</style>

<style lang="scss">
#cc-brand-dropdown {
  .dropdown-toggle {
    font-size: 16px;
    font-family: MainFontBold, sans-serif;
    font-weight: normal;
    color: #49545C;
    min-width: 150px;
    &::after {
      border: 0;
      width: 9px;
      height: 6px;
      background: url('~@/assets/images/caret-down.svg') no-repeat center;
      position: relative;
      top: 3px;
    }
  }
  .dropdown-menu {
    width: 220px;
    max-height: 300px;
    overflow-y: auto;
    background: #fff;
    .dropdown-item {
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      .count {
        background: #FF2D2D;
        font-size: 14px;
        color: #fff;
        border-radius: 15px;
      }
    }
  }
}
</style>
